<div>
  <div>
    <h5>Constructor de Speaker</h5>
  </div>

  <lib-ngx-tts (ttsGenerated)="handleTtsGenerated($event)"></lib-ngx-tts>

  <br />
  <div>
    <p-button (click)="copyToClipboard()" [disabled]="formGroup.invalid" label="Copia Código" [rounded]="true"></p-button>
    <p-button (click)="showCode()" [disabled]="!tts()" label="Mostrar" [rounded]="true" severity="secondary"></p-button>
  </div>
</div>
